// @core/api/endpoints/search/federated_search.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FederatedSearchRequest,
  SearchResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Federated search across peers
 * Executes a search query against federated peer platforms. For internal use between platform instances.
 */
export async function FederatedSearch(
  data: FederatedSearchRequest,
  options?: RequestOptions
): Promise<SearchResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/federated`;
  const requestOptions = options;
  return client.post<SearchResponse>(requestPath, data, requestOptions);
}
